// extracted by mini-css-extract-plugin
export default {"container":"q1Xq2PY"};